import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { NotFound } from '@alatzidis/core'

import { Home } from './pages/Home'
import { HeadManager } from './seo/HeadManager'

// One chunk per section. Each section package exposes its routes at
// `@alatzidis/<section>/routes`; the light entry (`@alatzidis/<section>`) is
// just the artifact list the home page counts.
const Games = lazy(() => import('@alatzidis/games/routes'))
const Sound = lazy(() => import('@alatzidis/sound/routes'))
const Chess = lazy(() => import('@alatzidis/chess/routes'))
const Notes = lazy(() => import('@alatzidis/notes/routes'))
const Render = lazy(() => import('@alatzidis/render/routes'))

const loading = (
  <p className="px-6 py-10 font-mono text-xs uppercase tracking-[0.2em] text-[color:var(--color-muted)]">
    loading…
  </p>
)

export default function App() {
  return (
    <Suspense fallback={loading}>
      <HeadManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/games/*" element={<Games />} />
        <Route path="/sound/*" element={<Sound />} />
        <Route path="/chess/*" element={<Chess />} />
        <Route path="/notes/*" element={<Notes />} />
        <Route path="/render/*" element={<Render />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}
